import styled from 'styled-components'
import { COLOR, FONT_SIZE, NATIVE_BASE_COLORS } from '../../../../themes'
import { ORDER_MANAGER } from '../../../../helpers'

const setJustifyContent = (selectedTab) => {
  if (selectedTab === ORDER_MANAGER.VALUE.CATERING ||
    selectedTab === ORDER_MANAGER.VALUE.EQUIPMENT
  ) {
    return 'end'
  } else if (selectedTab === ORDER_MANAGER.VALUE.FACILITY) {
    return 'space-between'
  } else {
    return 'space-between'
  }
}

export const OrderBottomBarStyle = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 16px;
  height: ${84}px;
  width: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 0 32px 0 24px;
  border-top: 1px solid ${COLOR.GRAY_5};
  z-index: 3;
  background-color: ${COLOR.WHITE};

  button {
    min-width: 140px;
    height: 48px;
    padding: 8px 20px;
    border-radius: 4px;
    font-size: ${FONT_SIZE.XXS};
    font-family: NunitoRegular;
    text-align: center;
    cursor: pointer;
    border: 1px solid ${props => props.colorTheme ? props.colorTheme.MAIN : COLOR.GOLD_1};
    background-color: ${props => props.colorTheme ? props.colorTheme.MAIN : COLOR.GOLD_1};
    color: ${props => props.colorTheme ? props.colorTheme.FONT_COLOR.SINGLE_TONE : COLOR.BLACK}
  }

  .disabled {
    opacity: 0.24;
    cursor: unset;
  }

  .order-bottom-bar__box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: ${props => props.selectedTab && setJustifyContent(props.selectedTab)};
  }

  .order-bottom-bar__text-box {
    display: flex;
    flex-direction: column;

    p {
      padding: 0;
      margin: 0;
    }

    .order-bottom-bar__title {
      font-family: NunitoSansBold;
      font-size: ${FONT_SIZE.XXS};
      color: ${NATIVE_BASE_COLORS.TEXT[900]};
    }
    
    .order-bottom-bar__subtitle {
      font-family: NunitoRegular;
      font-size: ${FONT_SIZE.TN};
      color: ${NATIVE_BASE_COLORS.TEXT[500]};
  
    }
  }
`
